import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import createRootReducer from './reducers'
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
export const history = createBrowserHistory()
const store = createStore(
  createRootReducer(history),
  undefined,
  composeEnhancers(
    applyMiddleware(
      routerMiddleware(history)
    )
  )
)
export const dispatch = store.dispatch
export default store
